module.exports = new __parcel__URL__("gpoy.6c09d5b5.webp").toString();